import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';
import clientApi from '~/clientApi';
import { CREATOR_BENCHMARKS } from '~/queries/keys';

type UseGetCreatorBenchmarks = {
  managerId?: string;
  creatorIds: string[];
};

/** @deprecated - use useFetchCreatorBenchmarks instead */
export const useGetCreatorBenchmarks = () => {
  return useMutation(({ managerId, creatorIds }: UseGetCreatorBenchmarks) =>
    clientApi.managers.benchmarks({
      id: managerId as string,
      creators: creatorIds,
      pageSize: 100,
    }),
  );
};

export const useFetchCreatorBenchmarks = ({
  managerId,
  creatorIds,
}: UseGetCreatorBenchmarks) => {
  const router = useRouter();
  return useQuery({
    queryKey: [CREATOR_BENCHMARKS, { managerId, creatorIds }],
    queryFn: () => {
      if (router.asPath.includes('/media-kits/')) {
        return axios
          .get(
            `/api/creators/benchmarks?managerId=${managerId}&creatorId=${creatorIds[0]}`,
          )
          .then((r) => r.data);
      }

      return clientApi.managers.benchmarks({
        id: managerId as string,
        creators: creatorIds,
        pageSize: 100,
      });
    },
    enabled: Boolean(managerId) && creatorIds.length > 0,
  });
};
